import { FC } from 'react'
import { TiWarningOutline } from 'react-icons/ti'

import useIsValidUrlLength from 'src/hooks/useIsValidUrlLength'
import withLoading from 'src/utils/hocs/withLoading'
import Typography from '../../atoms/Typography'
import ShareDashboardModalBodyLoading from './ShareDashboardModalBodyLoading'
import ShareDashboardModalShareLink from './ShareDashboardModalShareLink'
import ShareDashboardModalUsers from './ShareDashboardModalUsers'

import * as styles from './ShareDashboard.scss'

const ShareDashboardModalBody: FC = () => {
  const isValidUrlLength = useIsValidUrlLength()

  return (
    <div>
      <ShareDashboardModalUsers />
      {isValidUrlLength ? (
        <ShareDashboardModalShareLink />
      ) : (
        <div className={styles.ShareDashboardModalBodyShareLinkContainer}>
          <div className={styles.ShareDashboardModalBodyTitleSection}>
            <Typography variant="title2" fontSize={16}>
              Share your filter
            </Typography>
            <div className="flex items-center gap-1">
              <TiWarningOutline className="text-mango-tango size-4" />
              <span className="text-mango-tango inline-flex text-sm font-normal">
                This filter cannot be shared via link because it is too long.
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default withLoading(ShareDashboardModalBody, ShareDashboardModalBodyLoading)
